import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { companyInfo } from '../data/mock';

const HeroSection = ({ id }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id={id} 
      className="min-h-screen flex items-center relative overflow-hidden -mt-32 pt-32"
      style={{
        background: 'linear-gradient(135deg, #1a1c1b 0%, #302f2c 100%)'
      }}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-20 h-20 border border-brand-primary rounded-full"></div>
        <div className="absolute top-40 right-20 w-32 h-32 border border-brand-primary rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-brand-primary rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-24 h-24 border border-brand-primary rounded-full"></div>
      </div>

      <div className="container relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="space-y-8 fade-in-up">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 glass-card px-4 py-2 text-sm text-brand-primary border border-brand-primary/20">
              <Sparkles size={16} />
              <span>Consultoria em Design de Excelência</span>
            </div>

            {/* Main Headline */}
            <div className="space-y-4">
              <h1 className="brand-display leading-tight">
                Design que
                <br />
                <span className="text-white">conecta</span>
                <br />
                inovação
              </h1>
              <div className="w-20 h-1 bg-brand-primary rounded-full"></div>
            </div>

            {/* Subtitle */}
            <p className="body-large max-w-lg">
              {companyInfo.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="btn-primary group"
              >
                Iniciar Projeto
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
              </button>
              <button 
                onClick={() => {
                  const element = document.getElementById('portfolio');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-secondary"
              >
                Ver Portfólio
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-8 pt-8 border-t border-gray-700">
              <div className="text-center sm:text-left">
                <div className="heading-3 text-brand-primary">50+</div>
                <div className="body-small">Projetos</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="heading-3 text-brand-primary">5+</div>
                <div className="body-small">Anos</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="heading-3 text-brand-primary">100%</div>
                <div className="body-small">Satisfação</div>
              </div>
            </div>
          </div>

          {/* Right Content - Visual Element */}
          <div className="relative fade-in">
            <div className="relative">
              {/* Main Visual Card */}
              <div className="glass-card p-8 transform rotate-3 hover:rotate-0 transition-all duration-500">
                <div className="space-y-6">
                  <div className="flex items-center justify-between">
                    <div className="w-8 h-8 bg-brand-primary rounded-full"></div>
                    <div className="flex gap-2">
                      <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-brand-primary rounded-full"></div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="h-4 bg-gray-600 rounded w-3/4"></div>
                    <div className="h-4 bg-gray-600 rounded w-1/2"></div>
                    <div className="h-20 bg-gradient-to-br from-brand-primary/20 to-transparent rounded-lg border border-brand-primary/30"></div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="h-12 bg-gray-600/30 rounded"></div>
                      <div className="h-12 bg-brand-primary/20 rounded border border-brand-primary/50"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-brand-primary rounded-full opacity-80 animate-pulse"></div>
              <div className="absolute -bottom-6 -left-6 w-8 h-8 border-2 border-brand-primary rounded-full"></div>
              
              {/* Background Blur Circle */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-primary/5 rounded-full blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-brand-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-brand-primary rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;